import React, { Component } from "react";
import "./CartItems.css";
import {  Row, Col } from "react-bootstrap";
import * as actions from '../../Store/Actions/index'
import { connect } from 'react-redux'
class CartItems extends Component{

  render(){
    console.log(this.props.addedBooks)
    return (
      <div>
        {this.props.addedBooks.map((book,index) => {
          return (
            <Row key = {index} className="buyingList">
              <Col sm={6}>
                <div className="cart-book-container">
                  <div className="cart-image-container">
                    <img src={book.image} alt = "book"/>
                  </div>
                  <div className="text-container">
                    <div className="book-name">{book.title}</div>
                    <div className="book-isbn">{book.isbn}</div>
                    <div className="book-isbn">Class - {book.class_name}</div>
                      <div className="book-price">₹ {book.price}</div>
                  </div>
                </div>
              </Col>
              <Col sm={3}>
                <div className="quantity-container">
                  {
                    this.props.type === 'cart' ? 
                    (
                      <div className="button-wrapper">
                      <button className="decrement arithmetic-button " onClick = {() =>this.props.decreaseItem(book.bmid)}> - </button>
                      <div className="countInput">{book.quantity}</div>
                      <button className="increment arithmetic-button " onClick = {() =>this.props.increaseItem(book.bmid)}> + </button>
                    </div>
                    )
                    :
                    <div className = "quantity-container"><span className = "visible">Quantity :</span>  {book.quantity}</div>

                  }
                </div>
              </Col>
              <Col sm={3}>
                  <div className = "bottom-content">
                      ₹ {book.totalBookPrice}
                  </div>
              </Col>
            </Row>
          );
        })}
      </div>
    );
  }
 
};

const mapStateToProps = state => {
  return{
  addedBooks : state.book.addedBooks
}

}

const mapDispatchToPops = dispatch => {
  return{
  increaseItem : (id) => dispatch(actions.increaseItem(id)),
  decreaseItem : (id) => dispatch(actions.decreaseItem(id))
    
  }
}


export default connect(mapStateToProps,mapDispatchToPops)(CartItems);
